import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fetches live Google rating + review count (via backend proxy). Falls back
// gracefully to { configured:false } when the Places API key is not set.
let _cache = null;

export const useGoogleReviews = () => {
  const [data, setData] = useState(_cache);

  useEffect(() => {
    if (_cache) return;
    let active = true;
    fetch(`${API}/reviews/google`)
      .then((r) => r.json())
      .then((d) => {
        _cache = d;
        if (active) setData(d);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return data || { configured: false, rating: null, total: null, reviews: [], url: null };
};
